var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7573 36.6257L4.77706 27.456L26.4738 15.0061L42.4542 24.176L20.7573 36.6257ZM47.1198 24.176C47.1198 23.6272 46.8222 23.1158 46.3429 22.8409L27.2547 11.8879C27.0139 11.7498 26.7438 11.6807 26.4738 11.6807C26.2037 11.6807 25.9338 11.7498 25.6929 11.8879L0.888391 26.121C0.409044 26.3959 0.111328 26.9074 0.111328 27.456C0.111328 28.0047 0.409044 28.5163 0.888298 28.7912L19.9764 39.7441C20.4504 40.0161 21.0644 40.0159 21.5383 39.7441L46.3429 25.511C46.8222 25.2362 47.1198 24.7246 47.1198 24.176Z",
    fill: "#517DAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97299 20.465C2.54754 20.709 2.2832 21.163 2.2832 21.6501C2.2832 22.1371 2.54754 22.591 2.9729 22.8352L20.2276 32.736C20.6484 32.9776 21.1937 32.9774 21.6145 32.736L44.0366 19.8701C44.4619 19.6261 44.7262 19.1721 44.7262 18.6851C44.7262 18.198 44.4619 17.7438 44.0366 17.4999L26.7819 7.59937C26.5681 7.47639 26.3282 7.41504 26.0884 7.41504C25.8487 7.41504 25.6089 7.47639 25.3951 7.59937L2.97299 20.465Z",
    fill: "#26ABBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66573 15.7755L26.3624 3.32559L42.3428 12.4953L20.6461 24.9452L4.66573 15.7755ZM46.2316 13.8302C46.7109 13.5555 47.0085 13.044 47.0085 12.4953C47.0085 11.9468 46.7109 11.4351 46.2316 11.1603L27.1434 0.207366C26.9026 0.0690909 26.6324 0 26.3624 0C26.0924 0 25.8225 0.0690909 25.5815 0.207273L0.77697 14.4405C0.297716 14.7152 0 15.2268 0 15.7755C0 16.324 0.297716 16.8357 0.77697 17.1104L19.8651 28.0632C20.3389 28.3354 20.9529 28.3352 21.4269 28.0633L46.2316 13.8302Z",
    fill: "#634E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.0b9af2ab1d60a763c012d434d8c44928.svg";
export { ForwardRef as ReactComponent };